import React from 'react';
import { Card, Button, Form, Row, Col, Modal } from 'react-bootstrap';
import { useMutation, useQueryClient } from 'react-query';
import { Formik } from 'formik';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import { HOCPHANTIENSI_API } from '../../../../utils/apiUrl';
import { Post } from '../../../../utils/httpProvider';
import { trangThaiHocPhanValue, objectLoaiHocPhan } from '../../../../utils/define';

const schema = yup.object().shape({
    loaiHocPhan: yup.string().required('Vui lòng chọn học phần'),
    tenHocPhan: yup.string().required('Vui lòng nhập tên học phần')
});

const HocPhanTienSiAdd = ({ hoSoId, setViewMode, refreshList }) => {
    const queryClient = useQueryClient();

    const addFunc = useMutation((value) => Post(HOCPHANTIENSI_API.CREATE, null, value, false));

    const handleCreate = (values, { setSubmitting }) => {
        const requestData = {
            HoSoNghienCuuSinhId: hoSoId,
            LoaiHocPhan: values.loaiHocPhan,
            TenHocPhan: values.tenHocPhan,
            TuNgay: values.tuNgay || null,
            DenNgay: values.denNgay || null,
            TrangThai: trangThaiHocPhanValue.choHoc
        };

        addFunc.mutate(requestData, {
            onSuccess: (res) => {
                setSubmitting(false);
                if (res && (res.status === 200 || res.status === 201 || res.status === 204)) {
                    toast.success('Thêm mới thành công');
                    queryClient.invalidateQueries(['hocPhanTienSiData', hoSoId]);
                    if (refreshList) {
                        refreshList();
                    }
                    setViewMode('list');
                } else {
                    toast.error(res?.message || 'Có lỗi xảy ra');
                }
            },
            onError: (err) => {
                setSubmitting(false);
                toast.error(err?.message || 'Có lỗi xảy ra trong quá trình xử lý');
            }
        });
    };

    return (
        <Modal show={true} onHide={() => setViewMode('list')} size="lg" backdrop="static">
            <Modal.Header closeButton className="bg-primary text-white">
                <Modal.Title>Thêm mới Học phần tiến sĩ</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={handleCreate}
                    initialValues={{
                        loaiHocPhan: '',
                        tenHocPhan: '',
                        tuNgay: '',
                        denNgay: ''
                    }}
                >
                    {({ handleSubmit, handleChange, handleBlur, values, errors, touched, isSubmitting }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Loại học phần <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            as="select"
                                            name="loaiHocPhan"
                                            value={values.loaiHocPhan}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        >
                                            <option value="">Chọn học phần</option>
                                            {objectLoaiHocPhan.map((item, index) => (
                                                <option key={index} value={item.value}>{item.label}</option>
                                            ))}
                                        </Form.Control>
                                        {touched.loaiHocPhan && !!errors.loaiHocPhan && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>{errors.loaiHocPhan}</div>}
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Tên học phần <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="tenHocPhan"
                                            value={values.tenHocPhan}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {touched.tenHocPhan && !!errors.tenHocPhan && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>{errors.tenHocPhan}</div>}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Từ ngày</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="tuNgay"
                                            value={values.tuNgay}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Đến ngày</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="denNgay"
                                            value={values.denNgay}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <div className="text-right mt-3">
                                <Button variant="secondary" className="mr-2" onClick={() => setViewMode('list')} disabled={isSubmitting}>
                                    Hủy
                                </Button>
                                <Button variant="primary" type="submit" disabled={isSubmitting}>
                                    {isSubmitting ? <><i className="fas fa-spinner fa-spin mr-1"></i> Đang lưu...</> : <><i className="fas fa-save mr-1"></i> Lưu lại</>}
                                </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    );
};

export default HocPhanTienSiAdd;
